module.exports = __webpack_public_path__ + "media/images/create_course-489b70e4.png";